import { useEffect, useState } from 'react';
import { tableHeader, tableData } from '../utils/style';
import { equipmentTransferSchema } from '../utils/data';
import axios from 'axios';
import { url } from '../utils/config';

function InventoryTransfer() {
    const [ transferList, setTransferList ] = useState([equipmentTransferSchema, equipmentTransferSchema, equipmentTransferSchema, equipmentTransferSchema])

    // useEffect(() => { fetchTransferList() }, [])

    

    return(
        <div className="p-4">
            <div className="text-4xl font-semibold pb-8 font-family-audiowide">INVENTORY TRANSFER</div>
            <div className="grid grid-cols-7">
                <div className="col-span-2 p-4">
                    <div className="border border-gray-400 p-4 bg-blue-400 bg-opacity-25">
                        <div className="font-semibold text-mdc">Quantity</div>
                        <input placeholder="Enter Quantity" className="outline-none border-2 border-gray-300 rounded-full px-4 py-2 mt-2 mb-4 w-full" />
                        <div className="font-semibold text-md ">or Search for Product</div>
                        <input placeholder="Search" className="outline-none border-2 border-gray-300 rounded-full px-4 py-2 mt-2 mb-4 w-full"/>
                        <div className="font-semibold text-md ">or Add Product ID</div>
                        <input placeholder="Enter Product ID" className="outline-none border-2 border-gray-300 rounded-full px-4 py-2 mt-2 mb-4 w-full"/>
                        <div className="flex mt-2 mb-4 justify-between">
                            <div className='text-white text-md font-semibold bg-teal-400 py-1 px-2 cursor-pointer mr-4 rounded-md '>Add Item</div>
                            <div className="text-gray-500 text-md font-semibold ">or</div>
                            <div className='text-white text-md font-semibold bg-blue-400 py-1 px-2 cursor-pointer ml-4 rounded-md '>Batch Add Items</div>
                        </div>
                        <div className="font-semibold text-md ">Transfer to</div>
                        <select className="outline-none border-2 border-gray-300 rounded-full px-4 py-2 mt-2 mb-4 w-full" ></select>
                        <div className='text-white font-semibold bg-teal-400 p-2 cursor-pointer text-center rounded-md '>Process This Transfer</div>
                    </div>
                </div>
                <div className="col-span-5 p-4">
                    <div>
                        <table className='w-full'>
                            <thead>
                                <tr>
                                    <th className={ tableHeader }>Item Name</th>
                                    <th className={ tableHeader }>Quantity</th>
                                    <th className={ tableHeader }>Transfer to</th>
                                    <th className={ tableHeader }>Action</th>
                                </tr>
                            </thead>
                            <div className='mt-2 h-2 w-full'></div>
                            <tbody>
                                {
                                    transferList.map((transfer, index) => 
                                    <><tr key={index} className="border border-gray-200">
                                        <td className={ tableData }>{transfer.equipmentId}</td>
                                        <td className={ tableData }>{transfer.quantity}</td>
                                        <td className={ tableData }>{transfer.to}</td>
                                        <td className={ tableData }>
                                            <span className='bg-green-500 px-3 py-1 cursor-pointer mr-2'>Transfer</span>
                                            <span className='bg-red-500 px-3 py-1 cursor-pointer'>Cancel</span>
                                        </td>
                                    </tr>
                                    <div className='mt-2 w-full'></div>
                                    </>)
                                }
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    )

}

export default InventoryTransfer;